import gql from 'graphql-tag';

const TROUBLESHOOT_EXPORT_DEVICE_QUERY = gql`
  query Query($searchParam: String, $searchText: String, $appliedFilters: [String]) {
    exportDeviceTroubleShootDashboard(
      searchParam: $searchParam
      searchText: $searchText
      appliedFilters: $appliedFilters
    ) {
      code
      message
    }
  }
`;

export default TROUBLESHOOT_EXPORT_DEVICE_QUERY;
